import {TablePlatformSettingsModel} from '@/models/platform-settings.model';
import {BaseApi, RequireAuthApi} from '@/api/base.api';
import {axiosInstanceAuthenticated} from '@/api/axios.config.api';
import {map, retry} from 'rxjs/operators';

export class PlatformSettingsApi extends BaseApi<TablePlatformSettingsModel> {
  constructor() {
    super('platform-settings', [
      RequireAuthApi.DESTROY,
      RequireAuthApi.UPDATE,
      RequireAuthApi.CREATE,
    ]);
  }

  updateSettings(newSettings: TablePlatformSettingsModel) {
    return axiosInstanceAuthenticated()
      .put<TablePlatformSettingsModel>('platform-settings', newSettings)
      .pipe(
        retry(1),
        map((response) => response.data),
      );
  }
}
